// Ticket status constants
export const TICKET_STATUS = {
  SUBMITTED: 'submitted',
  PICKED_UP: 'picked_up',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CLOSED: 'closed',
};

export const TICKET_STATUS_LABELS = {
  [TICKET_STATUS.SUBMITTED]: 'Submitted',
  [TICKET_STATUS.PICKED_UP]: 'Picked Up',
  [TICKET_STATUS.APPROVED]: 'Approved',
  [TICKET_STATUS.REJECTED]: 'Rejected',
  [TICKET_STATUS.ASSIGNED]: 'Assigned',
  [TICKET_STATUS.IN_PROGRESS]: 'In Progress',
  [TICKET_STATUS.COMPLETED]: 'Completed',
  [TICKET_STATUS.CLOSED]: 'Closed',
};

export const TICKET_STATUS_COLORS = {
  [TICKET_STATUS.SUBMITTED]: 'bg-blue-100 text-blue-800 border-blue-200',
  [TICKET_STATUS.PICKED_UP]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  [TICKET_STATUS.APPROVED]: 'bg-green-100 text-green-800 border-green-200',
  [TICKET_STATUS.REJECTED]: 'bg-red-100 text-red-800 border-red-200',
  [TICKET_STATUS.ASSIGNED]: 'bg-purple-100 text-purple-800 border-purple-200',
  [TICKET_STATUS.IN_PROGRESS]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  [TICKET_STATUS.COMPLETED]: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  [TICKET_STATUS.CLOSED]: 'bg-gray-100 text-gray-800 border-gray-200',
};

// Priority constants
export const PRIORITY = {
  URGENT: 'urgent',
  NORMAL: 'normal',
  LOW: 'low',
};

export const PRIORITY_LABELS = {
  [PRIORITY.URGENT]: 'Urgent',
  [PRIORITY.NORMAL]: 'Normal',
  [PRIORITY.LOW]: 'Low',
};

export const PRIORITY_COLORS = {
  [PRIORITY.URGENT]: 'bg-red-500 text-white',
  [PRIORITY.NORMAL]: 'bg-yellow-500 text-white',
  [PRIORITY.LOW]: 'bg-green-500 text-white',
};

// Job status constants
export const JOB_STATUS = {
  PENDING: 'pending',
  NAVIGATING: 'navigating',
  ARRIVED: 'arrived',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const JOB_STATUS_LABELS = {
  [JOB_STATUS.PENDING]: 'Pending',
  [JOB_STATUS.NAVIGATING]: 'On My Way',
  [JOB_STATUS.ARRIVED]: 'Arrived',
  [JOB_STATUS.IN_PROGRESS]: 'In Progress',
  [JOB_STATUS.COMPLETED]: 'Completed',
  [JOB_STATUS.CANCELLED]: 'Cancelled',
};

// User roles
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  AGENT: 'agent',
  FOC: 'foc',
  TECHNICIAN: 'technician',
  CUSTOMER: 'customer',
};

export const USER_ROLE_LABELS = {
  [USER_ROLES.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLES.AGENT]: 'Customer Service Agent',
  [USER_ROLES.FOC]: 'Field Ops Coordinator',
  [USER_ROLES.TECHNICIAN]: 'Technician',
  [USER_ROLES.CUSTOMER]: 'Customer',
};